import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FiltersComponent } from 'src/app/common/filters.component';

enum IsActiveOption {
	ACTIVE,
	NOT_ACTIVE,
	ALL,
}

@Component({
	selector: 'app-organization-filters',
	templateUrl: './organization-filters.component.html',
	styleUrls: ['./organization-filters.component.css'],
})
export class OrganizationFiltersComponent extends FiltersComponent implements OnInit {
	filters = {
		is_oskar: null,
		is_active: null,
		address_location: null,
		code_merlinx: null,
	};

	@Input() isOskar: boolean;
	@Input() isActive: boolean;
	@Input() locations: boolean;

	readonly IsActiveOption = IsActiveOption;
	filterIsActive = IsActiveOption.ALL;
	protected filtersDefinition = {
		is_oskar: {
			type: 'boolean',
			isOskar: false,
		},
		is_active: {
			type: 'boolean',
			isActive: true,
		},
		address_location: {
			type: 'string',
			isArray: true,
		},
	};

	private readonly destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		super.ngOnInit();
		this.selected.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
			switch (value.is_active) {
				case true:
					this.filterIsActive = IsActiveOption.ACTIVE;
					break;
				case false:
					this.filterIsActive = IsActiveOption.NOT_ACTIVE;
					break;
				default:
					this.filterIsActive = IsActiveOption.ALL;
			}
		});
	}

	onIsActiveChange(value: IsActiveOption): void {
		if (value === IsActiveOption.ACTIVE) {
			this.filters.is_active = true;
		} else if (value === IsActiveOption.NOT_ACTIVE) {
			this.filters.is_active = false;
		} else if (value === IsActiveOption.ALL) {
			this.filters.is_active = null;
		}
	}
}
